import { useContext, useRef } from 'react';
import { FirebaseAppContext } from 'libs.firebase_react';
import { useLocalizeMessage } from 'libs.nucleus';
import { MOMRegion } from 'libs.react';
import { DeploymentUtils } from '../../utils';
const DUPLICATE_LAUNCH_GUARD_MS = 1000;
export const useDeploymentUtils = ({ studyId }) => {
    const translate = useLocalizeMessage();
    const { logEvent } = useContext(FirebaseAppContext);
    const lastLaunchRef = useRef();
    const getRegionName = (region) => {
        switch (region) {
            case MOMRegion.CN:
                return translate('CN');
            case MOMRegion.EU:
                return translate('EU');
            case MOMRegion.US:
            case MOMRegion.LOCAL:
            default:
                return translate('US');
        }
    };
    const getFullRegionName = (region) => {
        switch (region) {
            case MOMRegion.CN:
                return translate('China');
            case MOMRegion.EU:
                return translate('Europe');
            case MOMRegion.US:
            case MOMRegion.LOCAL:
            default:
                return translate('United States');
        }
    };
    const launchDeployment = ({ app, environment, isProd = false, routePage, }) => {
        const url = DeploymentUtils.buildEnvironmentUrl({ app, environment, routePage });
        const now = Date.now();
        if (lastLaunchRef.current?.url === url && now - lastLaunchRef.current.timestamp < DUPLICATE_LAUNCH_GUARD_MS) {
            logEvent('launch_env_duplicate_ignored', {
                app,
                env_name: environment.name,
                launch_url: url,
                study_id: studyId,
            });
            return;
        }
        lastLaunchRef.current = { url, timestamp: now };
        logEvent(isProd ? 'launch_env_prod' : 'launch_env_sandbox', {
            app,
            env_name: environment.name,
            launch_url: url,
            study_id: studyId,
        });
        window.open(url, '_blank', 'noopener,noreferrer');
    };
    return { getRegionName, getFullRegionName, launchDeployment };
};
